import { Navigate } from 'react-router-dom';

import { RoutePath } from 'shared/constants/router';
import { useStudent, useUserRole } from 'shared/hooks/user';
import { UserRole } from 'shared/types';

import type {
  FC,
  PropsWithChildren as ProtectedObserveRouteProps,
} from 'react';

export const ProtectedObserveRoute: FC<ProtectedObserveRouteProps> = ({
  children,
}) => {
  const student = useStudent();
  const role = useUserRole();

  if (!student && (role === UserRole.Staff || role === UserRole.Admin)) {
    return <Navigate to={RoutePath.StudentObserver} />;
  }

  return <>{children}</>;
};
